import { range } from "lodash-es";

interface YearOption {
  value: string;
  label: number;
}

export const getYears = (futureYears?: number): YearOption[] => {
  const start = 1990;
  const end = new Date().getFullYear() + 1 + (futureYears || 0);
  const years = range(start, end, 1);
  return years.map(y => ({ value: y.toString(), label: y }));
};
